import { contractTypeOptions } from '@/constants/contract-type-options'
import { useCreateRequestContractChangeMutation } from '@/store/services/employee-contract.service'
import { useTranslation } from 'react-i18next'
import { FileInput } from '@/shared/components/file-input'

import { Button, Input } from '@material-tailwind/react'
import CustomSelect from '@/shared/components/custom-select'
import { useEffect, useMemo } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import PropTypes from 'prop-types'
import { toOptions } from '@/utils'

export const RequestContractChangeForm = ({ currentEmployee, roles }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const initialValues = {
    id: currentEmployee.activeContract.id,
    new_changes: {
      contract_type: currentEmployee.activeContract.contractType,
      finish_date: currentEmployee.activeContract.finishDate,
      employee_role_id: currentEmployee.activeContract.employeeRole.id
    }
  }

  const roleOptions = useMemo(() => {
    return toOptions({ data: roles.data })
  }, [roles])

  const [createRequestContractChange, { isSuccess, isLoading }] =
    useCreateRequestContractChangeMutation()

  const { handleChange, values, setFieldValue, handleSubmit } = useFormik({
    initialValues,
    onSubmit: createRequestContractChange
  })

  useEffect(() => {
    if (!isSuccess) return

    navigate(generatePath('/employees'))
  }, [isSuccess])

  useEffect(() => {
    if (values.new_changes.contract_type !== "fixed_term") {
      setFieldValue("new_changes.finish_date", "");
    }
  }, [values.new_changes.contract_type]);

  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-4 p-1'>
      <Input
        label={t('contract.one')}
        value={values.id}
        className='bg-gray-200'
        readOnly
      />

      <CustomSelect
        placeholder={t('contract.type')}
        options={contractTypeOptions}
        onChange={({ value }) =>
          setFieldValue('new_changes.contract_type', value)
        }
        value={contractTypeOptions.find(
          (contractTypeOption) =>
            contractTypeOption.value === values.new_changes.contract_type
        )}
      />

      <Input
        name='new_changes.finish_date'
        label={t('contract.finishDate')}
        value={values.new_changes.finish_date}
        type='date'
        onChange={handleChange}
        disabled={values.new_changes.contract_type !== "fixed_term"}
        required={values.new_changes.contract_type === "fixed_term"}
      />

      <CustomSelect
        placeholder={t('role.one')}
        onChange={({ value }) =>
          setFieldValue('new_changes.employee_role_id', value)
        }
        value={roleOptions.find(
          (roleOption) =>
            roleOption.value === values.new_changes.employee_role_id
        )}
        options={roleOptions}
        menuPlacement='auto'
        menuPosition='fixed'
      />

      <FileInput
        text='Carga un anexo del contrato'
        handleChange={(attachment) => setFieldValue('attachment', attachment)}
        value={values.attachment}
      />
      <div className='flex justify-between'>
        <Button
          variant='text'
          color='gray'
          onClick={() => navigate(generatePath('/employees'))}
        >
          Cancelar
        </Button>

        <Button type='submit' loading={isLoading}>
          Enviar solicitud
        </Button>
      </div>
    </form>
  )
}
RequestContractChangeForm.propTypes = {
  currentEmployee: PropTypes.object,
  roles: PropTypes.array
}
